import Sel from '@/shared/view/CssSelectors'

export default {
    ...Sel,
    consultaReacoesCardTotalReacoes: 'tSYxvF-reacoes-card-total-reacoes',
    consultaReacoesGrade: 'tSYxvF-reacoes-grade',
    gradeRowHead: 'tSYxvF-row-head',
    gradeMostLeftColumn: 'tSYxvF-most-left-column',
    gradeGravidadeSim: 'tSYxvF-gravidade-sim',
    gradeGravidadeNao: 'tSYxvF-gravidade-nao',
    gradeConferenciaForaBula: 'tSYxvF-conferencia-fora-bula',
    gradeConferenciaNaBula: 'tSYxvF-conferencia-na-bula',
    gradeConferenciaNaoVerificado: 'tSYxvF-conferencia-nao-verificado',
    gradeDefechoMorte: 'tSYxvF-defecho-morte'
}